module.exports = __webpack_public_path__ + "img/15.448b69d9.jpeg";